export { default as common } from "./common.mjs";
export { default as red } from "./red.mjs";
export { default as pink } from "./pink.mjs";
export { default as purple } from "./purple.mjs";
export { default as deepPurple } from "./deepPurple.mjs";
export { default as indigo } from "./indigo.mjs";
export { default as blue } from "./blue.mjs";
export { default as lightBlue } from "./lightBlue.mjs";
export { default as cyan } from "./cyan.mjs";
export { default as teal } from "./teal.mjs";
export { default as green } from "./green.mjs";
export { default as lightGreen } from "./lightGreen.mjs";
export { default as lime } from "./lime.mjs";
export { default as yellow } from "./yellow.mjs";
export { default as amber } from "./amber.mjs";
export { default as orange } from "./orange.mjs";
export { default as deepOrange } from "./deepOrange.mjs";
export { default as brown } from "./brown.mjs";
export { default as grey } from "./grey.mjs";
export { default as blueGrey } from "./blueGrey.mjs";